import axios from "axios";
import React from "react";

interface Sector {
  id: number;
  name: string;
}

export default function useSectors(): [Map<number, string>, boolean] {
  const [sectors, setSectors] = React.useState<Map<number, string>>(new Map());
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<Sector[]>("/sectors/")
      .then((response) => {
        setSectors(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, []);

  return [sectors, loading];
}
